import { __awaiter } from "tslib";
import { trackShare, initEventTracker, } from '@slickdeals/web-instrumentation';
export const initWebInstrumentation = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!window.dataLayer) {
        console.debug('DataLayer not found, skipping Web Instrumentation initialization');
        return;
    }
    initEventTracker({
        client: {
            dataLayer: window.dataLayer,
            url: window.location.href,
            device: {
                userAgent: window.navigator.userAgent,
            },
        },
    });
});
export const addToWindow = () => {
    window.sdWebInstrumentation = {
        trackShare,
    };
};
